import React from "react";
import Confirm from '@xem/look/Confirm';
import { callback as renderCallback} from "@xem/entity/classes/renderCallback";

const DataForm = (({ isOpen, innerRef, ...props}) => (
	<>{!__SERVER__ && (!!isOpen) && <><Confirm ref={innerRef} {...{ ...props, isOpen }} /></>}</>));

let ref = React.createRef();
export default renderCallback(ref, 'confirm', DataForm)